import { EEbiFormCategory, EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

/**
 * H8. Legalizacja pracy cudzoziemców: oświadczenie o powierzeniu pracy cudzoziemcowi, zezwolenie na pracę sezonową
 * (starosta — PUP) i zezwolenie na pracę (wojewoda) — ustawa z 20.03.2025 r. o warunkach dopuszczalności powierzania pracy
 * cudzoziemcom; wnioski wyłącznie przez system teleinformatyczny praca.gov.pl (art. 8 ust. 3 — złożone inaczej pozostają
 * bez rozpoznania), więc EBI tylko odsyła. Opłaty: rozporządzenie MRPiPS z 20.11.2025 r. (Dz.U. poz. 1622). Adres usługi
 * z katalogu (sprawdzony 2026-10-21, aplikacja wymaga logowania).
 */
const H8: IEbiFormDefinition = {
  code: "H8",
  version: 1,
  title: "Legalizacja pracy cudzoziemców (oświadczenie o powierzeniu pracy, zezwolenie na pracę sezonową, zezwolenie na pracę)",
  category: EEbiFormCategory.Labour,
  office: EEbiFormOffice.CountyUnit,
  description: "Oświadczenie o powierzeniu pracy cudzoziemcowi i zezwolenia na pracę — wnioski składa się wyłącznie w praca.gov.pl.",
  keywords: ["cudzoziemiec", "oświadczenie o powierzeniu pracy", "zezwolenie na pracę", "praca sezonowa", "legalizacja pracy", "PUP", "wojewoda"],
  organ: "Starosta — Powiatowy Urząd Pracy (oświadczenie o powierzeniu pracy, zezwolenie na pracę sezonową); wojewoda (zezwolenie na pracę)",
  legalBasis:
    "art. 8 ust. 2–3, art. 45–67 ustawy z dnia 20 marca 2025 r. o warunkach dopuszczalności powierzania pracy cudzoziemcom na terytorium Rzeczypospolitej Polskiej",
  fee: "Oświadczenie — 400 zł; zezwolenie na pracę sezonową — 100 zł; zezwolenie na pracę (wojewoda) — 200, 400 albo 800 zł.",
  external: {
    service: "praca.gov.pl",
    url: "https://www.praca.gov.pl/eurzad/index.eup",
    text: "Oświadczenie o powierzeniu pracy cudzoziemcowi, zezwolenie na pracę sezonową i jego przedłużenie składa się wyłącznie w praca.gov.pl (Usługi elektroniczne → Zatrudnianie cudzoziemców), z podpisem zaufanym lub kwalifikowanym — wniosek złożony w inny sposób pozostaje bez rozpoznania. Przygotuj skan wszystkich wypełnionych stron dokumentu podróży cudzoziemca, dowód wniesienia opłaty (oświadczenie — 400 zł, zezwolenie sezonowe — 100 zł) i oświadczenia podmiotu powierzającego pracę. Zezwolenie na pracę (także przy delegowaniu i pełnieniu funkcji) wydaje wojewoda — wniosek również składa się w praca.gov.pl.",
  },
  sections: [],
  attachments: [],
};

export default H8;
